// ----------------------------------------------------------------------
// <copyright file="Izenda.CachingConfigInput.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import React from 'react';
import classnames from 'classnames';
import { observer } from 'mobx-react';
import Validator from 'share/components/hoc/Izenda.Validator';
import Input from 'share/components/controls/Izenda.Input';
const Numeric = Validator()(require('share/components/controls/Izenda.NumericInput'));
import GridLayout from 'share/components/controls/Izenda.GridLayout';
import { REQUIRE_CONSTRAINTS, max } from 'logic/data/Izenda.CachingConstants';
import EventUtils from 'EventUtils';
const CachingConfigInput = props => {
  const {
    type,
    notHaveRefresh,
    notHaveTooltip,
    tooltipText,
    defaultValue,
    refreshTooltip,
    valManager,
    dataKey,
    group
  } = props;
  const clazzName = classnames({ 'validation required': props.isRequired });
  const refreshToDefaultValue = () => {
    handleChange(defaultValue);
    valManager.reset(dataKey, group);
  };
  const handleChange = value => {
    props.onChange(props.dataKey, value);
  };

  return (
    <GridLayout.Row className='Izenda_Caching_ConfigInput'>
      <GridLayout.Col cols={2}>
        <label className={clazzName}>{props.title}</label>
        {!notHaveTooltip && <a className='icon-info-circled u_alignMiddle' title={tooltipText} />}
      </GridLayout.Col>
      <GridLayout.Col cols={4}>{renderControl()}</GridLayout.Col>
      <GridLayout.Col cols={0.5}>
        <label>{props.timeUnitText}</label>
      </GridLayout.Col>
      {!notHaveRefresh && (
        <GridLayout.Col cols={1}>
          <span className='icon-ccw resetButton' onClick={refreshToDefaultValue} title={refreshTooltip} />
        </GridLayout.Col>
      )}
    </GridLayout.Row>
  );

  function renderControl() {
    if (type === 'checkbox') {
      return (
        <Input
          checked={props.value}
          type='checkbox'
          onChange={EventUtils.notifyChange(handleChange, EventUtils.CHECKBOX)}
        />
      );
    } else if (type === 'numeric') {
      return (
        <Numeric
          value={props.value}
          onChange={handleChange}
          field={props.dataKey}
          validations={REQUIRE_CONSTRAINTS}
          group={props.group}
          max={max}
          isDecimal={false}
          isPositive
        />
      );
    }
  }
};

export default observer(CachingConfigInput);



// WEBPACK FOOTER //
// ./ui/modules/Settings/SystemConfiguration/Caching/Izenda.CachingConfigInput.js